import { useCallback } from "react";
import { useSaveDistributorSpecialPriceMutation } from "../mutations/useSaveDistributorSpecialPrice.mutation";
import { TDistributorSpecialPriceForm } from "../types/distributorSpecialPrice.types";

export const useSaveDistributorSpecialPrice = () => {
  const saveMutation = useSaveDistributorSpecialPriceMutation();

  const handleSave = useCallback(
    (values: TDistributorSpecialPriceForm) => {
      saveMutation.mutate(values);
    },
    [saveMutation],
  );

  return {
    handleSave,
    isSaving: saveMutation.isPending,
  };
};
